/* Klaviyo subscription helper for Barriers storefront components. */
function initBwKlaviyoEmailForm(options) {
  var form = document.getElementById(options.formId);
  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var input = form.querySelector('input[type="email"]');
    var status = document.getElementById(options.statusId);
    var button = form.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';
    var phoneInput = form.querySelector('input[type="tel"]');
    var phone = phoneInput ? phoneInput.value.trim() : '';
    var profileAttributes = { email: email };

    if (!email) return;
    if (phone) profileAttributes.phone_number = phone;
    if (button) button.disabled = true;
    if (status) status.textContent = 'Submitting…';

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(options.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: options.customSource || 'Website Signup Form',
            profile: { data: { type: 'profile', attributes: profileAttributes } }
          },
          relationships: { list: { data: { type: 'list', id: options.listId } } }
        }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Subscription request failed.');
        form.reset();
        if (status) status.textContent = 'Thanks — you are signed up.';
      })
      .catch(function () {
        if (status) status.textContent = 'Unable to sign you up. Please try again.';
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  });
}
